module.exports = __webpack_public_path__ + "static/media/user-150x150.3029cda2.png";